// extracted by mini-css-extract-plugin
export var divider = "_dt-7";
export var itemsToggle = "_dt-8";
export var mergeModal = "_dt-1";
export var optionCard = "_dt-4";
export var radioGroup = "_dt-6";
export var radioOption = "_dt-0";
export var selected = "_dt-5";
export var shipmentOptions = "_dt-2";
export var tableOptions = "_dt-3";